<template>
    <b-navbar toggleable="lg" id="navbar">
        <b-navbar-brand href="#">
            <img :src="`${publicPath}/img/oripay-white-logo.png`" width="80px"/>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
            <b-nav-item 
                href="/"
                :class="{ active: isActive('/') }"
            >{{ $t('Deposit') }}</b-nav-item>
            <b-nav-item 
                href="term-and-conditions"
                :class="{ active: isActive('/term-and-conditions') }"
            >{{ $t('Terms and Conditions') }}</b-nav-item>
            <b-nav-item 
                href="privacy-and-policy"
                :class="{ active: isActive('/privacy-and-policy') }">{{ $t('Privacy Policy') }}</b-nav-item>
            <!-- <b-nav-item href="#">Contact Us</b-nav-item> -->
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto language d-flex flex-row align-items-center justify-content-center">
            <b-nav-item @click.prevent="setLanguage('en')">English</b-nav-item>
            <b-nav-item @click.prevent="setLanguage('zh_cn')">简体中文</b-nav-item>
            <b-nav-item @click.prevent="setLanguage('zh_tw')">繁體中文</b-nav-item>
            <b-nav-item @click.prevent="setLanguage('ja_ja')">日本語</b-nav-item>
        </b-navbar-nav>
        </b-collapse>
    </b-navbar>
       
</template>

<script>
    export default {
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:''
            }
        },
        methods:{
            isActive(path) {
                return window.location.pathname === path;
            },
            setLanguage(lang){
                localStorage.setItem('lang',lang);
                window.location.reload(true);
            }
        }
    }
</script>